<div class="page-wrapper">
  <section class="banner">
    <div class="marketing-banner-wrapper">
      <div
        class="marketing-banner marketing-video-banner"
        *ngIf="pageData.video_id && pageData.hero_type === 'video'"
      >
        <iframe [src]="youtubeUrl()" frameborder="0" allowfullscreen></iframe>
      </div>
      <div
        class="marketing-banner marketing-image-banner"
        *ngIf="pageData.hero_type === 'image'"
      >
        <h1 class="ta-center">{{ pageData.name }}</h1>

        <p>{{ pageData.description }}</p>
        <img
          *ngIf="pageData.image && pageData.hero_type === 'image'"
          [src]="pageData.image.data.attributes.url"
        />
        <app-cms-link *ngIf="cta" [link]="cta" [class]="'button'">{{
          cta.label
        }}</app-cms-link>
      </div>
    </div>
  </section>
  <section class="white">
    <div class="content-wrapper">
      <div *ngFor="let marketingItem of pageData.body">
        <div
          class="marketing-content-container"
          *ngIf="marketingItem.slice_type === 'marketing_content'"
        >
          <h2 *ngIf="marketingItem.primary['content_heading']">
            {{ marketingItem.primary['content_heading'] }}
          </h2>
          <div
            class="marketing-content-content"
            *ngIf="marketingItem.primary['content_text']"
            [innerHTML]="marketingItem.primary['content_text']"
          ></div>
        </div>
        <app-tabs-slice
          *ngIf="marketingItem.slice_type === 'tabs'"
          [slice]="marketingItem"
        ></app-tabs-slice>
      </div>
    </div>
  </section>
</div>
